import { useEffect, useState, useRef } from "react";
import { getOLTs } from "../api/olt.api"; // ⚡ mantenemos para contar OLTs
import { getDashboardSummaryNew } from "../api/dashboard_summary.api"; // ⚡ usamos el nuevo endpoint
import { FaUsers, FaUserSlash, FaNetworkWired, FaPlug } from "react-icons/fa";
import { useAuth } from "../auth/useAuth";

export default function Dashboard() {
  const { initialized } = useAuth();

  const [data, setData] = useState({
    clients_active: 0,
    clients_suspended: 0,
    olts_up: 0,
    onus_online: 0,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const lastDataRef = useRef(null);

  useEffect(() => {
    if (!initialized) return;

    loadInitial();

    const interval = setInterval(() => {
      refreshSilent();
    }, 60000);

    return () => clearInterval(interval);
  }, [initialized]);

  const loadInitial = async () => {
    setLoading(true);
    setError(null);
    try {
      const [res, oltsList] = await Promise.all([getDashboardSummaryNew(), getOLTs()]);

      const newData = {
        clients_active: res?.clients_active ?? 0,
        clients_suspended: res?.clients_suspended ?? 0,
        olts_up: Array.isArray(oltsList) ? oltsList.length : 0,
        onus_online: res?.onus_online ?? 0, // ⚡ conteo de ONUs online
      };

      lastDataRef.current = newData;
      setData(newData);
    } catch (err) {
      console.error("Error inicial dashboard:", err);
      setError("No se pudo cargar el dashboard");
    } finally {
      setLoading(false);
    }
  };

  const refreshSilent = async () => {
    try {
      const [res, oltsList] = await Promise.all([getDashboardSummaryNew(), getOLTs()]);

      const newData = {
        clients_active: res?.clients_active ?? 0,
        clients_suspended: res?.clients_suspended ?? 0,
        olts_up: Array.isArray(oltsList) ? oltsList.length : 0,
        onus_online: res?.onus_online ?? 0,
      };

      if (!lastDataRef.current || JSON.stringify(lastDataRef.current) !== JSON.stringify(newData)) {
        lastDataRef.current = newData;
        setData(newData);
      }
    } catch (err) {
      console.warn("Refresh dashboard falló (ignorado)");
    }
  };

  if (!initialized || loading) return <p>Cargando dashboard...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>
      <h2 style={styles.title}>Dashboard General</h2>
      <div style={styles.grid}>
        <Card
          title="Clientes activos"
          value={data.clients_active}
          color="#22c55e"
          icon={<FaUsers size={28} />}
        />
        <Card
          title="Clientes suspendidos"
          value={data.clients_suspended}
          color="#ef4444"
          icon={<FaUserSlash size={28} />}
        />
        <Card
          title="OLTs conectadas"
          value={data.olts_up}
          color="#3b82f6"
          icon={<FaNetworkWired size={28} />}
        />
        <Card
          title="ONUs online"
          value={data.onus_online}
          color="#f59e0b"
          icon={<FaPlug size={28} />}
        />
      </div>
    </>
  );
}

function Card({ title, value, color, icon }) {
  return (
    <div style={{ ...styles.card, borderTop: `4px solid ${color}` }}>
      <div style={styles.cardHeader}>
        <div>{icon}</div>
        <h4 style={styles.cardTitle}>{title}</h4>
      </div>
      <strong style={{ ...styles.cardValue, color }}>{value ?? 0}</strong>
    </div>
  );
}

const styles = {
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 16,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
  },
  card: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "transform 0.2s",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 12,
  },
  cardTitle: {
    fontSize: 16,
    margin: 0,
    color: "#334155",
  },
  cardValue: {
    fontSize: 32,
    fontWeight: "bold",
  },
};
